import React, { useEffect } from "react";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import BreadcrumbElem from "./BreadcrumbElem.tsx";

const Breadcrumbs = ({ folderId }) => {
  const { getPathToFolder, setCurrentFolder, getCurrentFolder } = useMail();

  const currentFolderId = folderId || getCurrentFolder();

  useEffect(() => {
    if (document.querySelector(".breadcrumbs-container")) {
      const headerElem =
        document.querySelector(".functional-header") ||
        document.querySelector(".selection-header");
      if (
        document.querySelector(".breadcrumbs-container").getBoundingClientRect()
          .top <
        headerElem.getBoundingClientRect().top + 90
      ) {
        document.querySelector(".breadcrumbs-container").scrollIntoView();
        window.scrollBy(0, -80);
      }
    }
  }, [currentFolderId]);

  return currentFolderId ? (
    <div className="breadcrumbs-container">
      {getPathToFolder(currentFolderId).length > 0 && getCurrentFolder() && (
        <div
          className="breadcrumb-text home"
          onClick={() => setCurrentFolder(0)}
        >
          <i className="fas fa-home"></i>
        </div>
      )}
      {getPathToFolder(currentFolderId).map((folder) => (
        <BreadcrumbElem
          folderData={folder}
          folderId={folderId}
          key={folderId}
        />
      ))}
    </div>
  ) : null;
};

export default Breadcrumbs;
